<!-- @format -->
<template>
    <div>
        <div class="popup-backdrop" v-if="widgets.length > 0"></div>
        <transition-group name="slide">
            <sliding-widget
                v-for="(widget, index) in widgets"
                :class="['widget']"
                :index="index"
                :style="widgetStyles[index]"
                :widget="widget"
                :options="widget.options"
                :key="widget.name"
            />
        </transition-group>
    </div>
</template>

<script>
import SlidingWidget from '@/components/sliding-widgets/sliding-widget';

import EventBus from '@/scripts/event-bus';
import { LogLevel } from '@/scripts/logger';

export default {
    components: {
        'sliding-widget': SlidingWidget,
    },

    data() {
        return {
            maxWidth: 700,
            widgets: [],
            underReviewWidgets: [
                'bulk-one-to-one-email-widget',
                'email-template-widget',
                'marketing-plan-template-widget',
                'marketing-plan-widget',
                'campaign-widget',
                'journey-widget',
                'create-social-post-widget',
                'journey-template-widget',
                'one-to-one-email-widget',
            ],
        };
    },

    computed: {
        isAccountUnderReview() {
            return this.$store.state.context.client.underReview;
        },
        widgetStyles() {
            return this.widgets.map((widget, index) => {
                return {
                    'max-width': `${this.maxWidth}px`,
                    ...(index !== 0 && { 'box-shadow': 'none' }),
                };
            });
        },
    },

    methods: {
        showWidget(widget) {
            if (this.isAccountUnderReview && this.underReviewWidgets.includes(widget.name)) {
                this.$helpers.showFailNotification(
                    'Unable to perform this action while your account is under review.',
                    { level: LogLevel.INFO },
                );
                return;
            }

            if (!this.widgets.includes(widget)) {
                this.widgets.push(widget);
            }

            this.$helpers.hideBodyOverflow();
        },

        hideWidget(widget) {
            if (this.widgets.includes(widget)) {
                this.widgets.splice(this.widgets.indexOf(widget), 1);
            }

            if (this.widgets.length <= 0) {
                this.$helpers.showBodyOverflow();
            }
        },

        hideWidgets() {
            this.widgets = [];
            this.$helpers.showBodyOverflow();
        },
    },

    created() {
        EventBus.$on('open-widget', this.showWidget);
        EventBus.$on('close-widget', this.hideWidget);
        EventBus.$on('close-widgets', this.hideWidgets);
    },

    beforeDestroy() {
        EventBus.$off('open-widget', this.showWidget);
        EventBus.$off('close-widget', this.hideWidget);
        EventBus.$off('close-widgets', this.hideWidgets);
    },
};
</script>
